import styled, { css } from 'styled-components'
import { Link as OrigLink } from 'gatsby'
import { media } from 'utils/styleUtils'
import {
  WHITE,
  SPANISH_GRAY,
  MAIN_RED,
  PAGAMO_RED,
  BLACK,
} from 'constants/colors'
import { Container as PaperAirplaneContainer } from './PaperAirplane'
import HelpLogo from './HelpLogo'

export const Content = styled.div`
  margin: 0 auto;
  max-width: 1080px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${media.desktop} {
    padding: 0.8rem;
  }
`

export const Toggle = styled.input.attrs({
  type: 'checkbox',
})`
  position: absolute;
  top: 0;
  right: 0;
  height: 44px;
  width: 52px;
  opacity: 0;
  z-index: 2;
  cursor: pointer;

  ${media.desktop} {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  margin: 0.5rem;
  height: 36px;
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;

    svg {
      max-width: 90px;
      height: 30px;
    }
  }

  ${media.desktop} {
    margin: 0;
  }

  ${Toggle}:checked ~ & {
    display: none;

    ${media.desktop} {
      display: block;
    }
  }
`

export const HelpHeader = {}
HelpHeader.Title = styled.span`
  margin: 0 0.5rem;
  color: ${PAGAMO_RED};
  font-size: 18px;
`
HelpHeader.Logo = HelpLogo

export const Hamburger = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 44px;
  width: 52px;
  background-color: ${MAIN_RED};
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;

  ::before {
    content: '';
    position: absolute;
    top: 11px;
    left: 15px;
    height: 4px;
    width: 22px;
    background-color: ${WHITE};
    border-radius: 2px;
    transform-origin: 0 0;
    transition: transform 0.3s ease-out;
  }

  > span {
    position: absolute;
    top: 19px;
    left: 15px;
    height: 4px;
    width: 22px;
    background-color: ${WHITE};
    border-radius: 2px;
    transform-origin: 0 50%;
    transition: all 0.3s ease-out;
  }

  ::after {
    content: '';
    position: absolute;
    top: 27px;
    left: 15px;
    height: 4px;
    width: 22px;
    background-color: ${WHITE};
    border-radius: 2px;
    transform-origin: 0 100%;
    transition: transform 0.3s ease-out;
  }

  ${media.desktop} {
    display: none;
  }

  ${Toggle}:checked ~ & {
    ::before {
      transform: rotate(45deg) scaleX(1.1);
    }

    & > span {
      opacity: 0;
      transform: scaleX(0);
    }

    &::after {
      transform: rotate(-46deg) scaleX(1.1);
    }
  }
`

export const Actions = styled.ul`
  display: none;
  margin: 0;
  padding: 2rem 0;
  width: 100%;
  background-color: ${MAIN_RED};

  ${media.desktop} {
    display: flex;
    align-items: center;
    padding: 0;
    width: auto;
    background-color: transparent;
  }

  ${Toggle}:checked ~ & {
    display: flex;
    align-items: center;
    flex-direction: column;

    ${media.desktop} {
      flex-direction: row;
    }
  }
`

const Link = styled(OrigLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.8rem;
  padding: 0.8rem 0;
  font-size: 18px;
  color: ${WHITE};

  ${media.desktop} {
    padding: 0.5rem 0;
    font-size: 14px;
    color: ${SPANISH_GRAY};
  }

  svg {
    display: none;

    ${media.desktop} {
      display: inline;
    }
  }
`

export const IconLink = styled(Link)`
  ${media.desktop} {
    :hover {
      color: ${PAGAMO_RED};

      g {
        stroke: ${PAGAMO_RED};
      }
    }
  }
`

export const TextLink = styled(Link)`
  flex-direction: column;
  padding-top: 9px;
  padding-bottom: 0;

  ::after {
    content: '';
    height: 3px;
    width: 0;
    display: block;
    margin-top: 6px;
    background-color: ${PAGAMO_RED};
    transition: width 0.3s;
  }

  ${media.desktop} {
    :hover {
      color: ${PAGAMO_RED};

      ::after {
        width: 100%;
      }
    }
  }
`

export const ButtonLink = styled(Link)`
  order: -1;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  padding: 0.5rem 4rem;
  border-radius: 5px;
  border: 1px solid ${WHITE};
  color: ${WHITE};

  ${media.desktop} {
    order: 0;
    margin: 0 0.8rem;
    padding: 0.3rem 1rem;
    border: 1px solid ${PAGAMO_RED};
    background-color: ${PAGAMO_RED};
    cursor: pointer;
  }
`

const styledHeader = css`
  background-color: transparent;
  box-shadow: none;

  ${LogoWrapper} {
    svg {
      path,
      polygon {
        fill: ${WHITE} !important;
      }
    }
  }

  ${PaperAirplaneContainer} {
    color: ${WHITE};
    g {
      stroke: ${WHITE};
    }
  }

  ${Link} {
    color: ${WHITE};
  }

  ${TextLink} {
    ::after {
      background-color: ${WHITE};
    }
  }

  ${ButtonLink} {
    color: ${BLACK};
    background-color: ${WHITE};
    border: 1px solid ${WHITE};
  }
`

export const Container = styled.div`
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100%;
  transition: all 0.3s ease;
  background-color: ${WHITE};
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);

  ${media.desktop} {
    position: fixed;

    ${({ showStyledHeader }) => showStyledHeader && styledHeader}
  }
`
